export enum AnalyticsCategory {
  Accounting = 'Accounting',
  AllActivities = 'All activities',
  AnnualReport = 'Annual report',
  AdvisoryTools = 'Advisory tools',
  Clients = 'Clients',
  CollaborationBundles = 'Collaboration bundles',
  FirmSettings = 'Firm settings',
  IncomeTaxReturn = 'Income tax return',
  Notifications = 'Notifications',
  Other = 'Other',
  PartnerProgram = 'Partner program',
  Salary = 'Salary',
  StatementOfIncome = 'Statement of income',
  SustainabilityReporting = 'Sustainability reporting',
  TaxDeclaration = 'Tax declaration',
  ToDo = 'To do',

  MainNavigationMenu = 'Main navigation menu',
}
